var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaintBrush64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.376 43.725l-4.512 4.513a3.837 3.837 0 01-5.426 0l-3.424-3.424a1.918 1.918 0 00-2.713 0l-.081.087-8.007 10.288a5.987 5.987 0 11-8.402-8.402l10.196-7.93a1.92 1.92 0 00.337-2.693l-.158-.178-3.424-3.424a3.837 3.837 0 010-5.426l4.513-4.512 21.101 21.101z",
    fillOpacity: 0.15,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7 7.624l15.676 15.675a3.837 3.837 0 010 5.426L36.864 48.238a3.837 3.837 0 01-5.426 0l-3.424-3.424a1.918 1.918 0 00-2.713 0l-.081.087-8.007 10.288a5.987 5.987 0 11-8.402-8.402l10.196-7.93a1.92 1.92 0 00.337-2.693l-.158-.178-3.424-3.424a3.837 3.837 0 010-5.426L35.275 7.624a3.837 3.837 0 015.426 0z",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "currentColor",
    cx: 12.5,
    cy: 51.5,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 3,
    d: "M20 22l22 22"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round",
    d: "M45 12L35 22m17-3l-6 6"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaintBrush64);
export default __webpack_public_path__ + "static/media/paint-brush-64.60c7eacb.svg";
export { ForwardRef as ReactComponent };